export default {
  name: 'history',
  components: {},
  props: [],
  data () {
    return {
      history: []
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    show (history) {
      this.history = history
      this.$refs.historyModal.show()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/view/checklist-item/history/history.js